<div class='container-fluid print' style='font-family:irsans;font-size:10px;background-color: #fff;padding-top:1rem'>
    <div class='row'>
        <div class='col-md-12 col-sm-12 col-xs-12 boxall'>
            <div class="row">
                <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 invoice-header invoice-header1'>
                    <span>طراحی ، تولید و اجرای ساختمان های پیش ساخته LSF فروش ورق و سازه های فلزی</span>
                </div>
                <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 invoice-header invoice-header2'
                    style='text-align:center' (click)="get_customer()">
                    <span style='font-size:1rem;'>فاکتور فروش کالا و خدمات</span>
                </div>
                <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 invoice-header invoice-hedaer3'
                    style="text-align: left">
                    <span><img src="https://hooshmandsazeh.com/object/images/logohoshfa.png"></span>
                </div>
            </div>




            <!--بحش مشخصات خریدار 2-->


            <table style='padding:0px !important;'>
                <tr>
                    <td class='td-c9'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-box1'>مشخصات فروشنده</td>
                            </tr>
                        </table>
                    </td>
                    <td class='td-c27'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-box2'>شرکت مهندسین هوشمند سازه آروین آرا</td>
                            </tr>
                            <tr>
                                <td class='td-box3'>
                                    نشانی: تهران-صادقیه شمالی-بزرگراه جلال آل احمد نرسیده به اشرفی اصفهانی پلاک417 طبقه
                                    منفی یک
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td class='td-c8'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-box4'>شماره ثبت</td>
                            </tr>
                            <tr>
                                <td class='td-box5'>تلفن / نمابر</td>
                            </tr>
                            <tr>
                                <td class='td-box4'>کد پستی</td>
                            </tr>
                        </table>
                    </td>
                    <td class='td-c9'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-box4'>271493</td>
                            </tr>
                            <tr>
                                <td class='td-box5'>021-4579</td>
                            </tr>
                            <tr>
                                <td class='td-box4'>1461634446</td>
                            </tr>
                        </table>
                    </td>

                    <td class='td-c8'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-box6'>کد اقتصادی</td>
                            </tr>
                            <tr>
                                <td class='td-box6'>شناسه ملی</td>
                            </tr>
                        </table>
                    </td>



                    <td class='td-c39'>
                        <table class='table-code-sale table-fa' style='padding:0px !important;'>
                            <tr>
                                <td>1</td>
                                <td>5</td>
                                <td>1</td>
                                <td>1</td>
                                <td>3</td>
                                <td>3</td>
                                <td>5</td>
                                <td>4</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>4</td>
                                <td class='width-td-a' (click)="hide_invoice_number()">شماره</td>
                                <td class='width-td-b'><span *ngIf="hide">{{ code_factor }}</span></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>3</td>
                                <td>8</td>
                                <td>6</td>
                                <td>9</td>
                                <td>5</td>
                                <td>0</td>
                                <td>3</td>
                                <td>0</td>
                                <td>1</td>
                                <td>0</td>
                                <td>1</td>
                                <td class='width-td-a'>تاریخ</td>
                                <td class='width-td-b'>{{ date }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td class='td-c9'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-xb1'>مشخصات خریدار</td>
                            </tr>
                        </table>
                    </td>
                    <td class='td-c0' colspan='4'>
                        <table class='table-fa' style='padding:0px !important;'>
                            <tr>
                                <td class='td-xb2'> نام خریدار : {{ customer_title }} </td>
                                <td class='td-xb3'> کد پستی </td>
                                <td class='td-xb4'>{{ customer_post_code }}</td>
                            </tr>
                            <tr>
                                <td class='td-xb5'> نشانی : {{ customer_address }}</td>
                                <td class='td-xb3'> تلفن</td>
                                <td class='td-xb4'>{{ customer_cellphone }}</td>
                            </tr>
                        </table>
                    </td>

                    <td class='td-c39'>
                        <table class='table-code-buy table-fa'
                            style='padding:0px !important;border-left:solid 1px #000'>
                            <tr>
                                <td class='width-code-buy'>کد اقتصادی</td>
                                <td *ngFor="let x of list_economic_id">{{ x }}</td>

                            </tr>
                            <tr>
                                <td class='width-code-buy'>شناسه ملی</td>
                                <td *ngFor="let x of list_national_id">{{ x }}</td>
                                <td></td>
                            </tr>
                        </table>
                    </td>
                </tr>

            </table>


            <table class='table table-factor'>
                <thead>
                    <tr>
                        <th style="max-width:1.8rem">ردیف</th>
                        <th>کد کالا</th>
                        <th style="min-width:7rem">شرح کالا</th>
                        <th>مقدار</th>
                        <th>واحد</th>
                        <th style="max-width:4.4rem"> مبلغ واحد (ریال) </th>
                        <th style="max-width:4rem"> مبلغ کل (ریال) </th>
                        <th style="max-width:4.4rem"> مبلغ تخفیف (ریال) </th>
                        <th style="max-width:6rem">مبلغ کل پس از تخفیف (ریال) </th>
                        <th style="max-width:6rem"> مالیات و عوارض (ریال) </th>
                        <th style="max-width:7rem"> مبلغ کل با احتساب مالیات و عوارض (ریال) </th>
                    </tr>
                </thead>
                <thead>
                    <tr *ngFor="let x of list_record;let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ x.wharehouse_material_id }}</td>
                        <td>
                            <div class="right">{{ x.wharehouse_material_title }}</div>
                        </td>
                        <td class="number">{{ x.wharehouse_order_number | number }}</td>
                        <td class="number">{{ x.wharehouse_weight_title }}</td>
                        <td class="number">{{ x.wharehouse_order_cost | number }}</td>
                        <td class="number">{{ x.sum | number}}</td>
                        <td class="number">{{ x.wharehouse_order_discount | number }}</td>
                        <td class="number">{{ x.sum - x.wharehouse_order_discount | number}}</td>
                        <td>{{ x.tax | number }}</td>
                        <td>{{ x.sum_after_tax | number }}</td>
                    </tr>

                    <tr>
                        <th style='background-color:#ccc !important'>-</th>
                        <th colspan='7' style='text-align:right !important;background-color:#ccc !important'>جمع کل به
                            حروف :
                            {{ sum_all_letters }}
                            ریال
                        </th>
                        <th style='background-color:#ccc !important'>
                            {{ sum_after_discount | number }}
                        </th>
                        <th style='background-color:#ccc !important'>
                            {{ sum_tax | number }}
                        </th>
                        <th style='background-color:#ccc !important'>
                            {{ sum_all_after_tax | number }}
                        </th>




                    <tr>
                        <td colspan='3' height='140px' class="footer2"
                            style='height:70px;text-align:right !important;vertical-align: top !important'>
                            توضیحات :
                        </td>
                        <td colspan='3' height='140px' class="footer2"
                            style='height:70px;text-align:right !important;vertical-align: top !important'>
                            مهر و امضا فروشنده :
                        </td>
                        <td colspan='3' height='140px' class="footer2"
                            style='height:70px;text-align:right !important;vertical-align: top !important'>
                            مهر و امضا خریدار :
                        </td>
                        <td colspan='3' height='140px' class="footer2"
                            style='height:70px;text-align:right !important;vertical-align: top !important'>
                            جمع کل
                            (به ریال) :
                            {{ sum_all_after_tax | number }}
                        </td>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</div>
<div class='col-md-12 ' style='text-align:right;margin:20px 0px !important'>
    <button class='btn_pe' onclick="javascript:window.print()"> پرینت </button>
</div>